import { render, staticRenderFns } from "./MarginGroup.vue?vue&type=template&id=2db13309&scoped=true&"
import script from "./MarginGroup.vue?vue&type=script&lang=js&"
export * from "./MarginGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db13309",
  null
  
)

export default component.exports